<!-- Table/list group with documents -->
<div class="mt-4 mb-3">
    <app-action-table-documents [documents]="documents"></app-action-table-documents>
</div>

<div class="d-none d-lg-block p-0">
    <hr class="hr">
</div>

<!-- Closeable wrapper with checklist -->
<div class="mt-4 mb-0">
    <closable-wrapper [title]="titleofChecklist()" [collapse]="false" [sessionStorageName]="'RequestBuilderStep3'">
        <app-checklist [useCheckboxes]="false"></app-checklist>
    </closable-wrapper>
</div>